import axios, { AxiosRequestConfig } from "axios";
import { getUser } from "./user";

interface IOptions extends AxiosRequestConfig {
  factory?: (a: any) => any;
  noProtect?: boolean;
  responseType?: "blob";
  apiKey?: string;
}

interface ApiError extends Error {
  status?: number;
  code?: string;
}

const errorMessages: Record<number, string> = {
  400: "Algo deu errado, tente novamente!",
  401: "Não autorizado!",
  403: "Acesso negado!",
  404: "Recurso indisponível no momento",
  500: "Erro interno do servidor",
};

const request = async (options: IOptions) => {
  const { factory, noProtect, responseType } = options;
  let instance = axios.create({
    baseURL: `${process.env.REACT_APP_API}`,
  });
  if (noProtect) {
    instance = axios.create({
      baseURL: `${process.env.REACT_APP_API}`,
    });
  } else if (options.apiKey) {
    instance = axios.create({
      baseURL: `${process.env.REACT_APP_API}`,
      headers: { "X-Api-Key": options.apiKey },
    });
  } else {
    const { token } = getUser();
    instance = axios.create({
      baseURL: `${process.env.REACT_APP_API}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    if (responseType === "blob") {
      instance = axios.create({
        responseType,
        baseURL: `${process.env.REACT_APP_API}`,
        headers: { Authorization: `Bearer ${token}` },
      });
    }
  }

  try {
    const result = await instance(options);
    if (typeof factory === "function") {
      return factory(result);
    }
    return result;
  } catch (error: any) {
    if (axios.isAxiosError(error) && error.response) {
      const status = error.response.status;

      const customError: ApiError = new Error(
        errorMessages[status] || "Ocorreu um erro inesperado",
      );

      customError.status = status;
      customError.code = "API_ERROR";

      throw process.env.NODE_ENV === "development" ? error : customError;
    } else {
      throw error;
    }
  }
};

export default request;
